import { library } from '@fortawesome/fontawesome-svg-core';
import { faChartBar, faPlayCircle, faPauseCircle, faImage, faHeart, faTrashCan, faSmileBeam,
  faClock, faListAlt, faCirclePlay, faCirclePause, faComments, faCalendarAlt, faStar } from '@fortawesome/free-regular-svg-icons'

library.add(faChartBar, faPlayCircle, faPauseCircle, faImage, faHeart, faTrashCan, faSmileBeam,
  faClock, faListAlt, faCirclePlay, faCirclePause, faComments, faCalendarAlt, faStar);
